import { Spinner } from '@cian/ui-kit';
import { clsx } from 'clsx';
import * as React from 'react';

import * as styles from './RoundActionButton.css';

/**
 * Тема кнопки:
 * * 'primary' — фон --accent-main-primary, иконка и спиннер --theme-white; в disabled не меняется
 * * 'secondary' — фон --background-secondary, иконка --icon-secondary-default; в disabled иконка --icon-secondary-disabled
 * * 'neutral' — фон --surface-neutral-selected, иконка --icon-secondary-default
 */
export type TRoundActionButtonTheme = 'primary' | 'secondary' | 'neutral';

type TRoundActionButtonProps = {
  children: React.ReactNode;
  theme: TRoundActionButtonTheme;
  dataName: string;
  dataTestId?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  onClick(): void;
};

/**
 * Круглая кнопка 32×32 с иконкой; во время загрузки показывает спиннер вместо содержимого и блокируется.
 */
export const RoundActionButton: React.FC<TRoundActionButtonProps> = ({
  children,
  theme,
  dataName,
  dataTestId,
  isDisabled,
  isLoading,
  onClick,
}) => {
  return (
    <button
      type="button"
      className={clsx(styles['button'], styles[`button--${theme}`])}
      disabled={isDisabled || isLoading}
      aria-busy={isLoading}
      onClick={onClick}
      data-name={dataName}
      data-testid={dataTestId}
    >
      {isLoading ? <Spinner size={16} colorType="inherit" /> : children}
    </button>
  );
};
